import { compose } from '@bem-react/core';
import {
    Icon as IconPresenter,
    withTypeClose
} from '@yandex-lego/components/Icon/desktop';

const Icon = compose(
    withTypeClose
)(IconPresenter);

export default Icon;
